export const PERMISSION_EFFECTS_OPTIONS = [
    { label: 'ALLOW', value: true },
    { label: 'DENY', value: false }
];

export const PERMISSION_TYPE_OPTIONS = [
    { label: 'Single', value: 'Single' },
    { label: 'Wildcard', value: 'Wildcard' }
];

export const GOLD_COMPANY_ID = '00000000-0000-0000-0000-000000000000';

export const CONDITIONS = [
    {
        label: 'LAUNCH_AS', value: 'LAUNCH_AS'
    }
];